var _path, _path2, _path3, _path4, _path5, _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 141,
    viewBox: "0 0 275 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 0.5L137 101L13 0.5H62.5Z",
    fill: "#FBD02A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 0L137 100.5L168.5 0H105Z",
    fill: "#FBD02A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275 40L138 101L275 88.5V40Z",
    fill: "#FBD02A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 0L137 100.5L261 0H211.5Z",
    fill: "#FBD02A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40L137 101L0 88.5V40Z",
    fill: "#FBD02A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 275,
    height: 100,
    transform: "translate(0 1)",
    fill: "#FFCB05",
    fillOpacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.012 57.1362C139.435 56.3829 139.647 56.0063 139.963 56.0063C140.279 56.0063 140.491 56.3829 140.914 57.1362L141.024 57.331C141.144 57.5451 141.204 57.6521 141.298 57.7227C141.392 57.7934 141.509 57.8196 141.742 57.872L141.955 57.9197C142.777 58.1042 143.188 58.1965 143.286 58.5084C143.383 58.8203 143.103 59.1453 142.543 59.7954L142.398 59.9635C142.239 60.1483 142.159 60.2406 142.123 60.3549C142.087 60.4691 142.099 60.5924 142.124 60.8388L142.145 61.0632C142.23 61.9305 142.272 62.3642 142.017 62.5569C141.761 62.7497 141.376 62.5739 140.606 62.2224L140.407 62.1315C140.188 62.0316 140.079 61.9816 139.963 61.9816C139.847 61.9816 139.738 62.0316 139.519 62.1315L139.32 62.2224C138.55 62.5739 138.166 62.7497 137.91 62.5569C137.654 62.3642 137.696 61.9305 137.781 61.0632L137.803 60.8388C137.827 60.5924 137.839 60.4691 137.803 60.3549C137.767 60.2406 137.688 60.1483 137.528 59.9635L137.383 59.7954C136.823 59.1453 136.543 58.8203 136.641 58.5084C136.738 58.1965 137.149 58.1042 137.971 57.9197L138.184 57.872C138.417 57.8196 138.534 57.7934 138.628 57.7227C138.722 57.6521 138.782 57.5451 138.902 57.331L139.012 57.1362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.962 55.0311C136.974 54.9898 137.047 54.9896 137.06 55.0307C137.115 55.2188 137.217 55.4967 137.371 55.649C137.526 55.8013 137.807 55.9008 137.997 55.9542C138.038 55.9659 138.039 56.0391 137.997 56.0511C137.808 56.1058 137.527 56.2072 137.374 56.3605C137.22 56.5138 137.12 56.7924 137.066 56.9808C137.054 57.0221 136.981 57.0223 136.969 56.9812C136.913 56.7931 136.811 56.5152 136.657 56.3629C136.502 56.2106 136.221 56.1111 136.031 56.0577C135.99 56.046 135.989 55.9728 136.031 55.9608C136.221 55.9061 136.501 55.8047 136.654 55.6514C136.808 55.4981 136.908 55.2195 136.962 55.0311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.518 55.3238C142.68 55.3238 142.812 55.4547 142.812 55.6163V55.7138H142.911C143.074 55.7138 143.206 55.8447 143.206 56.0063C143.206 56.1678 143.074 56.2988 142.911 56.2988H142.812V56.3963C142.812 56.5578 142.68 56.6888 142.518 56.6888C142.355 56.6888 142.223 56.5578 142.223 56.3963V56.2988H142.124C141.962 56.2988 141.83 56.1678 141.83 56.0063C141.83 55.8447 141.962 55.7138 142.124 55.7138H142.223V55.6163C142.223 55.4547 142.355 55.3238 142.518 55.3238Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8969 72.8137C17.7258 71.4686 18.1403 70.796 18.7599 70.796C19.3795 70.796 19.794 71.4686 20.6229 72.8137L20.8374 73.1617C21.0729 73.5439 21.1907 73.735 21.3743 73.8611C21.5579 73.9872 21.7866 74.034 22.244 74.1277L22.6604 74.2129C24.27 74.5424 25.0749 74.7071 25.2663 75.2641C25.4578 75.821 24.9091 76.4015 23.8118 77.5622L23.5279 77.8625C23.2161 78.1924 23.0602 78.3573 22.99 78.5614C22.9199 78.7654 22.9434 78.9855 22.9906 79.4255L23.0335 79.8262C23.1994 81.375 23.2824 82.1493 22.7811 82.4936C22.2798 82.8378 21.5263 82.524 20.0192 81.8963L19.6293 81.7338C19.2011 81.5555 18.9869 81.4663 18.7599 81.4663C18.5329 81.4663 18.3188 81.5555 17.8906 81.7338L17.5006 81.8963C15.9935 82.524 15.24 82.8378 14.7387 82.4936C14.2374 82.1493 14.3204 81.375 14.4863 79.8262L14.5292 79.4255C14.5763 78.9855 14.5999 78.7654 14.5298 78.5614C14.4596 78.3573 14.3037 78.1924 13.9919 77.8625L13.708 77.5622C12.6107 76.4015 12.062 75.821 12.2535 75.2641C12.445 74.7071 13.2498 74.5424 14.8594 74.2129L15.2758 74.1277C15.7332 74.034 15.9619 73.9872 16.1455 73.8611C16.3292 73.735 16.447 73.5439 16.6825 73.1617L16.8969 72.8137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8836 69.0555C12.9067 68.9818 13.0513 68.9814 13.0749 69.0549C13.1828 69.3907 13.383 69.887 13.6856 70.1589C13.9883 70.4309 14.5383 70.6086 14.9102 70.7039C14.9916 70.7248 14.9921 70.8556 14.9108 70.877C14.5396 70.9746 13.991 71.1557 13.6904 71.4295C13.3898 71.7033 13.1933 72.2008 13.0879 72.5372C13.0648 72.6109 12.9202 72.6113 12.8966 72.5378C12.7887 72.202 12.5885 71.7057 12.2859 71.4338C11.9832 71.1618 11.4332 70.9841 11.0613 70.8887C10.9799 70.8678 10.9794 70.7371 11.0607 70.7157C11.4319 70.6181 11.9805 70.437 12.2811 70.1632C12.5817 69.8894 12.7782 69.3919 12.8836 69.0555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7636 69.5772C24.0825 69.5772 24.3411 69.8111 24.3411 70.0996V70.2737H24.5335C24.8524 70.2737 25.1109 70.5075 25.1109 70.796C25.1109 71.0845 24.8524 71.3183 24.5335 71.3183H24.3411V71.4925C24.3411 71.7809 24.0825 72.0148 23.7636 72.0148C23.4448 72.0148 23.1862 71.7809 23.1862 71.4925V71.3183H22.9938C22.6749 71.3183 22.4164 71.0845 22.4164 70.796C22.4164 70.5075 22.6749 70.2737 22.9938 70.2737H23.1862V70.0996C23.1862 69.8111 23.4448 69.5772 23.7636 69.5772Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.897 62.8137C251.726 61.4686 252.14 60.796 252.76 60.796C253.38 60.796 253.794 61.4686 254.623 62.8137L254.837 63.1617C255.073 63.5439 255.191 63.735 255.374 63.8611C255.558 63.9872 255.787 64.034 256.244 64.1277L256.66 64.2129C258.27 64.5424 259.075 64.7071 259.266 65.2641C259.458 65.821 258.909 66.4015 257.812 67.5622L257.528 67.8625C257.216 68.1924 257.06 68.3573 256.99 68.5614C256.92 68.7654 256.943 68.9855 256.991 69.4255L257.034 69.8262C257.199 71.375 257.282 72.1493 256.781 72.4936C256.28 72.8378 255.526 72.524 254.019 71.8963L253.629 71.7338C253.201 71.5555 252.987 71.4663 252.76 71.4663C252.533 71.4663 252.319 71.5555 251.891 71.7338L251.501 71.8963C249.994 72.524 249.24 72.8378 248.739 72.4936C248.237 72.1493 248.32 71.375 248.486 69.8262L248.529 69.4255C248.576 68.9855 248.6 68.7654 248.53 68.5614C248.46 68.3573 248.304 68.1924 247.992 67.8625L247.708 67.5622C246.611 66.4015 246.062 65.821 246.253 65.2641C246.445 64.7071 247.25 64.5424 248.859 64.2129L249.276 64.1277C249.733 64.034 249.962 63.9872 250.146 63.8611C250.329 63.735 250.447 63.5439 250.682 63.1617L250.897 62.8137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.884 59.0555C246.907 58.9818 247.051 58.9814 247.075 59.0549C247.183 59.3907 247.383 59.887 247.686 60.1589C247.988 60.4309 248.538 60.6086 248.91 60.7039C248.992 60.7248 248.992 60.8556 248.911 60.877C248.54 60.9746 247.991 61.1557 247.69 61.4295C247.39 61.7033 247.193 62.2008 247.088 62.5372C247.065 62.6109 246.92 62.6113 246.897 62.5378C246.789 62.202 246.589 61.7057 246.286 61.4338C245.983 61.1618 245.433 60.9841 245.061 60.8887C244.98 60.8678 244.979 60.7371 245.061 60.7157C245.432 60.6181 245.98 60.437 246.281 60.1632C246.582 59.8894 246.778 59.3919 246.884 59.0555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.764 59.5772C258.083 59.5772 258.341 59.8111 258.341 60.0996V60.2737H258.534C258.852 60.2737 259.111 60.5075 259.111 60.796C259.111 61.0845 258.852 61.3183 258.534 61.3183H258.341V61.4925C258.341 61.7809 258.083 62.0148 257.764 62.0148C257.445 62.0148 257.186 61.7809 257.186 61.4925V61.3183H256.994C256.675 61.3183 256.416 61.0845 256.416 60.796C256.416 60.5075 256.675 60.2737 256.994 60.2737H257.186V60.0996C257.186 59.8111 257.445 59.5772 257.764 59.5772Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.897 12.8137C222.726 11.4686 223.14 10.796 223.76 10.796C224.38 10.796 224.794 11.4686 225.623 12.8137L225.837 13.1617C226.073 13.5439 226.191 13.735 226.374 13.8611C226.558 13.9872 226.787 14.034 227.244 14.1277L227.66 14.2129C229.27 14.5424 230.075 14.7071 230.266 15.2641C230.458 15.821 229.909 16.4015 228.812 17.5622L228.528 17.8625C228.216 18.1924 228.06 18.3573 227.99 18.5614C227.92 18.7654 227.943 18.9855 227.991 19.4255L228.034 19.8262C228.199 21.375 228.282 22.1493 227.781 22.4936C227.28 22.8378 226.526 22.524 225.019 21.8963L224.629 21.7338C224.201 21.5555 223.987 21.4663 223.76 21.4663C223.533 21.4663 223.319 21.5555 222.891 21.7338L222.501 21.8963C220.994 22.524 220.24 22.8378 219.739 22.4936C219.237 22.1493 219.32 21.375 219.486 19.8262L219.529 19.4255C219.576 18.9855 219.6 18.7654 219.53 18.5614C219.46 18.3573 219.304 18.1924 218.992 17.8625L218.708 17.5622C217.611 16.4015 217.062 15.821 217.253 15.2641C217.445 14.7071 218.25 14.5424 219.859 14.2129L220.276 14.1277C220.733 14.034 220.962 13.9872 221.146 13.8611C221.329 13.735 221.447 13.5439 221.682 13.1617L221.897 12.8137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.884 9.05549C217.907 8.98182 218.051 8.98138 218.075 9.05491C218.183 9.39067 218.383 9.88697 218.686 10.1589C218.988 10.4309 219.538 10.6086 219.91 10.7039C219.992 10.7248 219.992 10.8556 219.911 10.877C219.54 10.9746 218.991 11.1557 218.69 11.4295C218.39 11.7033 218.193 12.2008 218.088 12.5372C218.065 12.6109 217.92 12.6113 217.897 12.5378C217.789 12.202 217.589 11.7057 217.286 11.4338C216.983 11.1618 216.433 10.9841 216.061 10.8887C215.98 10.8678 215.979 10.7371 216.061 10.7157C216.432 10.6181 216.98 10.437 217.281 10.1632C217.582 9.88941 217.778 9.39191 217.884 9.05549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.764 9.57724C229.083 9.57724 229.341 9.8111 229.341 10.0996V10.2737H229.534C229.852 10.2737 230.111 10.5075 230.111 10.796C230.111 11.0845 229.852 11.3183 229.534 11.3183H229.341V11.4925C229.341 11.7809 229.083 12.0148 228.764 12.0148C228.445 12.0148 228.186 11.7809 228.186 11.4925V11.3183H227.994C227.675 11.3183 227.416 11.0845 227.416 10.796C227.416 10.5075 227.675 10.2737 227.994 10.2737H228.186V10.0996C228.186 9.8111 228.445 9.57724 228.764 9.57724Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.009 11.4757C147.994 9.89747 148.487 9.10834 149.223 9.10834C149.959 9.10834 150.452 9.89747 151.437 11.4757L151.692 11.8841C151.972 12.3325 152.112 12.5568 152.33 12.7048C152.548 12.8527 152.82 12.9076 153.364 13.0175L153.858 13.1175C155.771 13.5041 156.728 13.6973 156.955 14.3509C157.183 15.0044 156.531 15.6854 155.227 17.0473L154.889 17.3997C154.519 17.7868 154.334 17.9803 154.25 18.2197C154.167 18.4591 154.195 18.7173 154.251 19.2336L154.302 19.7038C154.499 21.5209 154.598 22.4295 154.002 22.8335C153.406 23.2374 152.511 22.8691 150.72 22.1326L150.256 21.942C149.747 21.7328 149.493 21.6281 149.223 21.6281C148.953 21.6281 148.699 21.7328 148.19 21.942L147.726 22.1326C145.935 22.8691 145.04 23.2374 144.444 22.8335C143.848 22.4295 143.947 21.5209 144.144 19.7038L144.195 19.2336C144.251 18.7173 144.279 18.4591 144.196 18.2197C144.113 17.9803 143.927 17.7868 143.557 17.3997L143.219 17.0473C141.915 15.6854 141.263 15.0044 141.491 14.3509C141.718 13.6973 142.675 13.5041 144.588 13.1175L145.082 13.0175C145.626 12.9076 145.898 12.8527 146.116 12.7048C146.334 12.5568 146.474 12.3326 146.754 11.8841L147.009 11.4757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.239 7.06511C142.266 6.97867 142.438 6.97815 142.466 7.06443C142.594 7.45838 142.832 8.04071 143.192 8.35979C143.551 8.67887 144.205 8.88737 144.647 8.99927C144.744 9.02378 144.744 9.17722 144.648 9.2023C144.207 9.31687 143.555 9.52931 143.197 9.85055C142.84 10.1718 142.607 10.7555 142.481 11.1503C142.454 11.2367 142.282 11.2372 142.254 11.151C142.126 10.757 141.888 10.1747 141.528 9.8556C141.168 9.53651 140.515 9.32801 140.073 9.21611C139.976 9.1916 139.976 9.03816 140.072 9.01307C140.513 8.89851 141.165 8.68607 141.523 8.36482C141.88 8.04358 142.113 7.45984 142.239 7.06511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.168 7.67834C155.547 7.67834 155.854 7.95274 155.854 8.29121V8.4955H156.083C156.462 8.4955 156.769 8.76989 156.769 9.10837C156.769 9.44684 156.462 9.72124 156.083 9.72124H155.854V9.92553C155.854 10.264 155.547 10.5384 155.168 10.5384C154.789 10.5384 154.482 10.264 154.482 9.92553V9.72124H154.253C153.874 9.72124 153.567 9.44684 153.567 9.10837C153.567 8.76989 153.874 8.4955 154.253 8.4955H154.482V8.29121C154.482 7.95274 154.789 7.67834 155.168 7.67834Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0091 6.47574C57.9941 4.89747 58.4867 4.10834 59.223 4.10834C59.9594 4.10834 60.452 4.89747 61.437 6.47574L61.6919 6.88406C61.9718 7.33254 62.1118 7.5568 62.33 7.70476C62.5482 7.85271 62.82 7.90764 63.3636 8.01748L63.8585 8.11749C65.7713 8.50407 66.7278 8.69733 66.9553 9.35089C67.1829 10.0044 66.5308 10.6854 65.2268 12.0473L64.8894 12.3997C64.5188 12.7868 64.3335 12.9803 64.2501 13.2197C64.1668 13.4591 64.1948 13.7173 64.2509 14.2336L64.3018 14.7038C64.499 16.5209 64.5976 17.4295 64.0018 17.8335C63.4061 18.2374 62.5106 17.8691 60.7196 17.1326L60.2562 16.942C59.7473 16.7328 59.4927 16.6281 59.223 16.6281C58.9533 16.6281 58.6988 16.7328 58.1899 16.942L57.7265 17.1326C55.9354 17.8691 55.0399 18.2374 54.4442 17.8335C53.8485 17.4295 53.947 16.5209 54.1442 14.7038L54.1952 14.2336C54.2512 13.7173 54.2792 13.4591 54.1959 13.2197C54.1125 12.9803 53.9272 12.7868 53.5567 12.3997L53.2193 12.0473C51.9152 10.6854 51.2632 10.0044 51.4907 9.35089C51.7183 8.69733 52.6747 8.50407 54.5876 8.11749L55.0825 8.01748C55.6261 7.90764 55.8978 7.85271 56.1161 7.70476C56.3343 7.5568 56.4743 7.33255 56.7542 6.88406L57.0091 6.47574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2385 2.06511C52.2659 1.97867 52.4377 1.97815 52.4658 2.06443C52.5941 2.45838 52.832 3.04071 53.1917 3.35979C53.5513 3.67887 54.2049 3.88737 54.6469 3.99927C54.7437 4.02378 54.7443 4.17722 54.6477 4.2023C54.2066 4.31687 53.5546 4.52931 53.1973 4.85055C52.84 5.1718 52.6066 5.75554 52.4813 6.15027C52.4538 6.23671 52.282 6.23723 52.254 6.15095C52.1257 5.75699 51.8878 5.17467 51.5281 4.8556C51.1684 4.53651 50.5149 4.32801 50.0729 4.21611C49.9761 4.1916 49.9755 4.03816 50.0721 4.01307C50.5132 3.89851 51.1652 3.68607 51.5225 3.36482C51.8798 3.04358 52.1132 2.45984 52.2385 2.06511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1681 2.67834C65.547 2.67834 65.8543 2.95274 65.8543 3.29121V3.4955H66.083C66.462 3.4955 66.7692 3.76989 66.7692 4.10837C66.7692 4.44684 66.462 4.72124 66.083 4.72124H65.8543V4.92553C65.8543 5.264 65.547 5.53839 65.1681 5.53839C64.7891 5.53839 64.4819 5.264 64.4819 4.92553V4.72124H64.2531C63.8742 4.72124 63.5669 4.44684 63.5669 4.10837C63.5669 3.76989 63.8742 3.4955 64.2531 3.4955H64.4819V3.29121C64.4819 2.95274 64.7891 2.67834 65.1681 2.67834Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.012 88.1362C192.435 87.3829 192.647 87.0063 192.963 87.0063C193.279 87.0063 193.491 87.3829 193.914 88.1362L194.024 88.331C194.144 88.5451 194.204 88.6521 194.298 88.7227C194.392 88.7934 194.509 88.8196 194.742 88.872L194.955 88.9197C195.777 89.1042 196.188 89.1965 196.286 89.5084C196.383 89.8203 196.103 90.1453 195.543 90.7954L195.398 90.9635C195.239 91.1483 195.159 91.2406 195.123 91.3549C195.087 91.4691 195.099 91.5924 195.124 91.8388L195.145 92.0632C195.23 92.9305 195.272 93.3642 195.017 93.5569C194.761 93.7497 194.376 93.5739 193.606 93.2224L193.407 93.1315C193.188 93.0316 193.079 92.9816 192.963 92.9816C192.847 92.9816 192.738 93.0316 192.519 93.1315L192.32 93.2224C191.55 93.5739 191.166 93.7497 190.91 93.5569C190.654 93.3642 190.696 92.9305 190.781 92.0632L190.803 91.8388C190.827 91.5924 190.839 91.4691 190.803 91.3549C190.767 91.2406 190.688 91.1483 190.528 90.9635L190.383 90.7954C189.823 90.1453 189.543 89.8203 189.641 89.5084C189.738 89.1965 190.149 89.1042 190.971 88.9197L191.184 88.872C191.417 88.8196 191.534 88.7934 191.628 88.7227C191.722 88.6521 191.782 88.5451 191.902 88.331L192.012 88.1362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.962 86.0311C189.974 85.9898 190.047 85.9896 190.06 86.0307C190.115 86.2188 190.217 86.4967 190.371 86.649C190.526 86.8013 190.807 86.9008 190.997 86.9542C191.038 86.9659 191.039 87.0391 190.997 87.0511C190.808 87.1058 190.527 87.2072 190.374 87.3605C190.22 87.5138 190.12 87.7924 190.066 87.9808C190.054 88.0221 189.981 88.0223 189.969 87.9812C189.913 87.7931 189.811 87.5152 189.657 87.3629C189.502 87.2106 189.221 87.1111 189.031 87.0577C188.99 87.046 188.989 86.9728 189.031 86.9608C189.221 86.9061 189.501 86.8047 189.654 86.6514C189.808 86.4981 189.908 86.2195 189.962 86.0311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.518 86.3238C195.68 86.3238 195.812 86.4547 195.812 86.6163V86.7138H195.911C196.074 86.7138 196.206 86.8447 196.206 87.0063C196.206 87.1678 196.074 87.2988 195.911 87.2988H195.812V87.3963C195.812 87.5578 195.68 87.6888 195.518 87.6888C195.355 87.6888 195.223 87.5578 195.223 87.3963V87.2988H195.124C194.962 87.2988 194.83 87.1678 194.83 87.0063C194.83 86.8447 194.962 86.7138 195.124 86.7138H195.223V86.6163C195.223 86.4547 195.355 86.3238 195.518 86.3238Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.012 45.1362C192.435 44.3829 192.647 44.0063 192.963 44.0063C193.279 44.0063 193.491 44.3829 193.914 45.1362L194.024 45.331C194.144 45.5451 194.204 45.6521 194.298 45.7227C194.392 45.7934 194.509 45.8196 194.742 45.872L194.955 45.9197C195.777 46.1042 196.188 46.1965 196.286 46.5084C196.383 46.8203 196.103 47.1453 195.543 47.7954L195.398 47.9635C195.239 48.1483 195.159 48.2406 195.123 48.3549C195.087 48.4691 195.099 48.5924 195.124 48.8388L195.145 49.0632C195.23 49.9305 195.272 50.3642 195.017 50.5569C194.761 50.7497 194.376 50.5739 193.606 50.2224L193.407 50.1315C193.188 50.0316 193.079 49.9816 192.963 49.9816C192.847 49.9816 192.738 50.0316 192.519 50.1315L192.32 50.2224C191.55 50.5739 191.166 50.7497 190.91 50.5569C190.654 50.3642 190.696 49.9305 190.781 49.0632L190.803 48.8388C190.827 48.5924 190.839 48.4691 190.803 48.3549C190.767 48.2406 190.688 48.1483 190.528 47.9635L190.383 47.7954C189.823 47.1453 189.543 46.8203 189.641 46.5084C189.738 46.1965 190.149 46.1042 190.971 45.9197L191.184 45.872C191.417 45.8196 191.534 45.7934 191.628 45.7227C191.722 45.6521 191.782 45.5451 191.902 45.331L192.012 45.1362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.962 43.0311C189.974 42.9898 190.047 42.9896 190.06 43.0307C190.115 43.2188 190.217 43.4967 190.371 43.649C190.526 43.8013 190.807 43.9008 190.997 43.9542C191.038 43.9659 191.039 44.0391 190.997 44.0511C190.808 44.1058 190.527 44.2072 190.374 44.3605C190.22 44.5138 190.12 44.7924 190.066 44.9808C190.054 45.0221 189.981 45.0223 189.969 44.9812C189.913 44.7931 189.811 44.5152 189.657 44.3629C189.502 44.2106 189.221 44.1111 189.031 44.0577C188.99 44.046 188.989 43.9728 189.031 43.9608C189.221 43.9061 189.501 43.8047 189.654 43.6514C189.808 43.4981 189.908 43.2195 189.962 43.0311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.518 43.3238C195.68 43.3238 195.812 43.4547 195.812 43.6163V43.7138H195.911C196.074 43.7138 196.206 43.8447 196.206 44.0063C196.206 44.1678 196.074 44.2988 195.911 44.2988H195.812V44.3963C195.812 44.5578 195.68 44.6888 195.518 44.6888C195.355 44.6888 195.223 44.5578 195.223 44.3963V44.2988H195.124C194.962 44.2988 194.83 44.1678 194.83 44.0063C194.83 43.8447 194.962 43.7138 195.124 43.7138H195.223V43.6163C195.223 43.4547 195.355 43.3238 195.518 43.3238Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.012 39.1362C120.435 38.3829 120.647 38.0063 120.963 38.0063C121.279 38.0063 121.491 38.3829 121.914 39.1362L122.024 39.331C122.144 39.5451 122.204 39.6521 122.298 39.7227C122.392 39.7934 122.509 39.8196 122.742 39.872L122.955 39.9197C123.777 40.1042 124.188 40.1965 124.286 40.5084C124.383 40.8203 124.103 41.1453 123.543 41.7954L123.398 41.9635C123.239 42.1483 123.159 42.2406 123.123 42.3549C123.087 42.4691 123.099 42.5924 123.124 42.8388L123.145 43.0632C123.23 43.9305 123.272 44.3642 123.017 44.5569C122.761 44.7497 122.376 44.5739 121.606 44.2224L121.407 44.1315C121.188 44.0316 121.079 43.9816 120.963 43.9816C120.847 43.9816 120.738 44.0316 120.519 44.1315L120.32 44.2224C119.55 44.5739 119.166 44.7497 118.91 44.5569C118.654 44.3642 118.696 43.9305 118.781 43.0632L118.803 42.8388C118.827 42.5924 118.839 42.4691 118.803 42.3549C118.767 42.2406 118.688 42.1483 118.528 41.9635L118.383 41.7954C117.823 41.1453 117.543 40.8203 117.641 40.5084C117.738 40.1965 118.149 40.1042 118.971 39.9197L119.184 39.872C119.417 39.8196 119.534 39.7934 119.628 39.7227C119.722 39.6521 119.782 39.5451 119.902 39.331L120.012 39.1362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.962 37.0311C117.974 36.9898 118.047 36.9896 118.06 37.0307C118.115 37.2188 118.217 37.4967 118.371 37.649C118.526 37.8013 118.807 37.9008 118.997 37.9542C119.038 37.9659 119.039 38.0391 118.997 38.0511C118.808 38.1058 118.527 38.2072 118.374 38.3605C118.22 38.5138 118.12 38.7924 118.066 38.9808C118.054 39.0221 117.981 39.0223 117.969 38.9812C117.913 38.7931 117.811 38.5152 117.657 38.3629C117.502 38.2106 117.221 38.1111 117.031 38.0577C116.99 38.046 116.989 37.9728 117.031 37.9608C117.221 37.9061 117.501 37.8047 117.654 37.6514C117.808 37.4981 117.908 37.2195 117.962 37.0311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.518 37.3238C123.68 37.3238 123.812 37.4547 123.812 37.6163V37.7138H123.911C124.074 37.7138 124.206 37.8447 124.206 38.0063C124.206 38.1678 124.074 38.2988 123.911 38.2988H123.812V38.3963C123.812 38.5578 123.68 38.6888 123.518 38.6888C123.355 38.6888 123.223 38.5578 123.223 38.3963V38.2988H123.124C122.962 38.2988 122.83 38.1678 122.83 38.0063C122.83 37.8447 122.962 37.7138 123.124 37.7138H123.223V37.6163C123.223 37.4547 123.355 37.3238 123.518 37.3238Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.0118 60.1362C97.435 59.3829 97.6467 59.0063 97.9631 59.0063C98.2795 59.0063 98.4911 59.3829 98.9144 60.1362L99.0239 60.331C99.1442 60.5451 99.2044 60.6521 99.2981 60.7227C99.3919 60.7934 99.5087 60.8196 99.7422 60.872L99.9549 60.9197C100.777 61.1042 101.188 61.1965 101.286 61.5084C101.383 61.8203 101.103 62.1453 100.543 62.7954L100.398 62.9635C100.239 63.1483 100.159 63.2406 100.123 63.3549C100.087 63.4691 100.099 63.5924 100.124 63.8388L100.145 64.0632C100.23 64.9305 100.272 65.3642 100.017 65.5569C99.7605 65.7497 99.3757 65.5739 98.6061 65.2224L98.407 65.1315C98.1884 65.0316 98.079 64.9816 97.9631 64.9816C97.8472 64.9816 97.7378 65.0316 97.5191 65.1315L97.32 65.2224C96.5504 65.5739 96.1656 65.7497 95.9096 65.5569C95.6537 65.3642 95.696 64.9305 95.7807 64.0632L95.8027 63.8388C95.8267 63.5924 95.8388 63.4691 95.8029 63.3549C95.7671 63.2406 95.6875 63.1483 95.5283 62.9635L95.3833 62.7954C94.8229 62.1453 94.5428 61.8203 94.6405 61.5084C94.7383 61.1965 95.1493 61.1042 95.9713 60.9197L96.1839 60.872C96.4175 60.8196 96.5343 60.7934 96.628 60.7227C96.7218 60.6521 96.782 60.5451 96.9022 60.331L97.0118 60.1362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9619 58.0311C94.9737 57.9898 95.0475 57.9896 95.0596 58.0307C95.1147 58.2188 95.2169 58.4967 95.3714 58.649C95.526 58.8013 95.8068 58.9008 95.9967 58.9542C96.0383 58.9659 96.0386 59.0391 95.9971 59.0511C95.8075 59.1058 95.5274 59.2072 95.3739 59.3605C95.2203 59.5138 95.12 59.7924 95.0662 59.9808C95.0544 60.0221 94.9806 60.0223 94.9685 59.9812C94.9134 59.7931 94.8112 59.5152 94.6566 59.3629C94.5021 59.2106 94.2212 59.1111 94.0313 59.0577C93.9897 59.046 93.9895 58.9728 94.031 58.9608C94.2205 58.9061 94.5007 58.8047 94.6542 58.6514C94.8077 58.4981 94.908 58.2195 94.9619 58.0311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.518 58.3238C100.68 58.3238 100.812 58.4547 100.812 58.6163V58.7138H100.911C101.074 58.7138 101.206 58.8447 101.206 59.0063C101.206 59.1678 101.074 59.2988 100.911 59.2988H100.812V59.3963C100.812 59.5578 100.68 59.6888 100.518 59.6888C100.355 59.6888 100.223 59.5578 100.223 59.3963V59.2988H100.124C99.9617 59.2988 99.8296 59.1678 99.8296 59.0063C99.8296 58.8447 99.9617 58.7138 100.124 58.7138H100.223V58.6163C100.223 58.4547 100.355 58.3238 100.518 58.3238Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0118 81.1362C74.435 80.3829 74.6467 80.0063 74.9631 80.0063C75.2795 80.0063 75.4911 80.3829 75.9144 81.1362L76.0239 81.331C76.1442 81.5451 76.2044 81.6521 76.2981 81.7227C76.3919 81.7934 76.5087 81.8196 76.7422 81.872L76.9549 81.9197C77.7768 82.1042 78.1878 82.1965 78.2856 82.5084C78.3834 82.8203 78.1032 83.1453 77.5428 83.7954L77.3979 83.9635C77.2386 84.1483 77.159 84.2406 77.1232 84.3549C77.0874 84.4691 77.0994 84.5924 77.1235 84.8388L77.1454 85.0632C77.2301 85.9305 77.2725 86.3642 77.0165 86.5569C76.7605 86.7497 76.3757 86.5739 75.6061 86.2224L75.407 86.1315C75.1884 86.0316 75.079 85.9816 74.9631 85.9816C74.8472 85.9816 74.7378 86.0316 74.5191 86.1315L74.32 86.2224C73.5504 86.5739 73.1656 86.7497 72.9096 86.5569C72.6537 86.3642 72.696 85.9305 72.7807 85.0632L72.8027 84.8388C72.8267 84.5924 72.8388 84.4691 72.8029 84.3549C72.7671 84.2406 72.6875 84.1483 72.5283 83.9635L72.3833 83.7954C71.8229 83.1453 71.5428 82.8203 71.6405 82.5084C71.7383 82.1965 72.1493 82.1042 72.9713 81.9197L73.1839 81.872C73.4175 81.8196 73.5343 81.7934 73.628 81.7227C73.7218 81.6521 73.782 81.5451 73.9022 81.331L74.0118 81.1362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9619 79.0311C71.9737 78.9898 72.0475 78.9896 72.0596 79.0307C72.1147 79.2188 72.2169 79.4967 72.3714 79.649C72.526 79.8013 72.8068 79.9008 72.9967 79.9542C73.0383 79.9659 73.0386 80.0391 72.9971 80.0511C72.8075 80.1058 72.5274 80.2072 72.3739 80.3605C72.2203 80.5138 72.12 80.7924 72.0662 80.9808C72.0544 81.0221 71.9806 81.0223 71.9685 80.9812C71.9134 80.7931 71.8112 80.5152 71.6566 80.3629C71.5021 80.2106 71.2212 80.1111 71.0313 80.0577C70.9897 80.046 70.9895 79.9728 71.031 79.9608C71.2205 79.9061 71.5007 79.8047 71.6542 79.6514C71.8077 79.4981 71.908 79.2195 71.9619 79.0311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5176 79.3238C77.6805 79.3238 77.8125 79.4547 77.8125 79.6163V79.7138H77.9108C78.0736 79.7138 78.2056 79.8447 78.2056 80.0063C78.2056 80.1678 78.0736 80.2988 77.9108 80.2988H77.8125V80.3963C77.8125 80.5578 77.6805 80.6888 77.5176 80.6888C77.3548 80.6888 77.2228 80.5578 77.2228 80.3963V80.2988H77.1245C76.9617 80.2988 76.8296 80.1678 76.8296 80.0063C76.8296 79.8447 76.9617 79.7138 77.1245 79.7138H77.2228V79.6163C77.2228 79.4547 77.3548 79.3238 77.5176 79.3238Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.476 78.855H157.541V80.2078C157.541 81.702 156.374 82.9134 154.935 82.9134C153.496 82.9134 152.33 81.7018 152.33 80.2078V78.855H101.524C100.805 78.855 100.221 79.4607 100.221 80.2078V120.792C100.221 121.539 100.805 122.145 101.524 122.145H152.33V120.792C152.33 119.298 153.497 118.087 154.935 118.087C156.374 118.087 157.541 119.298 157.541 120.792V122.145H174.476C175.195 122.145 175.779 121.539 175.779 120.792V80.2078C175.779 79.4606 175.195 78.855 174.476 78.855Z",
    fill: "#FFDC64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.935 118.087C156.374 118.087 157.541 119.298 157.541 120.792V122.145H174.476C175.195 122.145 175.779 121.539 175.779 120.792V80.2078C175.779 79.4607 175.195 78.855 174.476 78.855H157.541V80.2078C157.541 81.702 156.374 82.9134 154.935 82.9134V118.087Z",
    fill: "#FFC850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.476 77.5866H157.541C156.866 77.5866 156.319 78.1544 156.319 78.855V80.2077C156.319 81.0003 155.698 81.6452 154.935 81.6452C154.172 81.6452 153.551 81.0003 153.551 80.2077V78.855C153.551 78.1546 153.004 77.5866 152.33 77.5866H101.524C100.132 77.5866 99 78.7624 99 80.2077V120.792C99 122.238 100.132 123.413 101.524 123.413H152.33C153.004 123.413 153.551 122.846 153.551 122.145V120.792C153.551 120 154.172 119.355 154.935 119.355C155.699 119.355 156.32 120 156.32 120.792V122.145C156.32 122.845 156.866 123.413 157.541 123.413H174.476C175.868 123.413 177 122.238 177 120.792V80.2077C177 78.7624 175.868 77.5866 174.476 77.5866ZM174.557 120.792C174.557 120.839 174.521 120.877 174.476 120.877H158.762V120.792C158.762 119.044 157.669 117.558 156.157 117.027V115.381C156.157 114.681 155.61 114.113 154.935 114.113C154.261 114.113 153.714 114.68 153.714 115.381V117.027C152.201 117.558 151.109 119.044 151.109 120.792V120.877H101.524C101.479 120.877 101.443 120.839 101.443 120.792V80.2077C101.443 80.1611 101.479 80.1233 101.524 80.1233H151.109V80.2077C151.109 81.9556 152.201 83.4424 153.714 83.973V85.6191C153.714 86.3195 154.261 86.8874 154.935 86.8874C155.61 86.8874 156.157 86.3196 156.157 85.6191V83.973C157.669 83.4424 158.762 81.9556 158.762 80.2077V80.1233H174.476C174.521 80.1233 174.557 80.1611 174.557 80.2077V120.792H174.557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.935 89.762C154.261 89.762 153.714 90.3298 153.714 91.0303V93.7359C153.714 94.4362 154.261 95.0042 154.935 95.0042C155.61 95.0042 156.157 94.4364 156.157 93.7359V91.0303C156.157 90.3299 155.61 89.762 154.935 89.762Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.935 97.8789C154.261 97.8789 153.714 98.4467 153.714 99.1472V101.853C153.714 102.553 154.261 103.121 154.935 103.121C155.61 103.121 156.157 102.553 156.157 101.853V99.1472C156.157 98.4467 155.61 97.8789 154.935 97.8789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.935 105.996C154.261 105.996 153.714 106.564 153.714 107.264V109.97C153.714 110.67 154.261 111.238 154.935 111.238C155.61 111.238 156.157 110.67 156.157 109.97V107.264C156.157 106.564 155.61 105.996 154.935 105.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.863 87.4278C138.386 86.9325 137.613 86.9325 137.136 87.4278L113.688 111.779C113.211 112.274 113.211 113.077 113.688 113.572C113.926 113.82 114.239 113.944 114.551 113.944C114.864 113.944 115.176 113.82 115.415 113.572L138.863 89.2214C139.34 88.7262 139.34 87.923 138.863 87.4278Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.459 99.0626C122.006 99.0626 124.891 96.066 124.891 92.3831C124.891 88.7001 122.006 85.7036 118.459 85.7036C114.913 85.7036 112.027 88.7001 112.027 92.3831C112.027 96.066 114.913 99.0626 118.459 99.0626ZM118.459 88.2401C120.659 88.2401 122.449 90.0986 122.449 92.3831C122.449 94.6675 120.659 96.5261 118.459 96.5261C116.259 96.5261 114.47 94.6675 114.47 92.3831C114.47 90.0986 116.259 88.2401 118.459 88.2401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.092 101.937C130.545 101.937 127.66 104.934 127.66 108.617C127.66 112.3 130.545 115.296 134.092 115.296C137.638 115.296 140.524 112.3 140.524 108.617C140.524 104.934 137.638 101.937 134.092 101.937ZM134.092 112.76C131.892 112.76 130.102 110.901 130.102 108.617C130.102 106.332 131.892 104.474 134.092 104.474C136.292 104.474 138.082 106.332 138.082 108.617C138.081 110.901 136.292 112.76 134.092 112.76Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_99",
    x: 136,
    y: 55,
    width: 7.30481,
    height: 11.6364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_99"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1_99",
    x: 11,
    y: 69,
    width: 14.3039,
    height: 17.6355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_99"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1_99",
    x: 245,
    y: 59,
    width: 14.3039,
    height: 17.6355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_99"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1_99",
    x: 216,
    y: 9,
    width: 14.3039,
    height: 17.6355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_99"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1_99",
    x: 140,
    y: 7,
    width: 17,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_99"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1_99",
    x: 50,
    y: 2,
    width: 17,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_99"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1_99",
    x: 189,
    y: 86,
    width: 7.30481,
    height: 11.6364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_99"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_1_99",
    x: 189,
    y: 43,
    width: 7.30481,
    height: 11.6364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_99"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_1_99",
    x: 117,
    y: 37,
    width: 7.3048,
    height: 11.6364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_99"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_1_99",
    x: 94,
    y: 58,
    width: 7.3048,
    height: 11.6364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_99"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_1_99",
    x: 71,
    y: 79,
    width: 7.3048,
    height: 11.6364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0 0.591346 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_99"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 81,
    fill: "white",
    transform: "translate(99 60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferSuccess);
export default __webpack_public_path__ + "static/media/offer_success.ce9b363e8227259adba1e9216dac2d28.svg";
export { ForwardRef as ReactComponent };